/**
 *
 * LanguageSelectModal
 *
 */

import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from '@reduxjs/toolkit';
// import styled from 'styled-components';

import { translate as t } from '../../utils/translator';

import Button from '../Button';

import { changeLanguageRequest, handleLanguageSelectModal } from '../../containers/LanguageProvider/actions';

const LANGUAGES = [
  {
    title: 'English', subTitle: 'English', code:'en'
  },
  {
    title: 'हिंदी', subTitle: 'Hindi', code:'hi'
  },
  {
    title: 'தமிழ்', subTitle: 'Tamil', code:'ta'
  },
  {
    title: 'తెలుగు', subTitle: 'Telugu', code:'te'
  },
  {
    title: 'ಕನ್ನಡ', subTitle: 'Kannada', code:'kn'
  },
  {
    title: 'മലയാളം', subTitle: 'Malayalam', code:'ml'
  }
]

function LanguageSelectModal(props) {

  const changeLanguageRequest = lang => {
    props.changeLanguageRequest(lang);
  };

  const handleModalClose = () => {
    props.handleModalClose(false);
  }

  if (props.languageSelectModal) {
    return (
      <div className="languageSelectPopUp">
        <div className="languageSelectBody">
           <div className="languageSelectHeader">
              <span className="material-icons languageSelectClose" onClick={handleModalClose}>close</span>
            </div>
            <div className="languageSelectDescription">
              <div className="languageInfo">All documents/SMS communications from axio will be in this language</div>
              <div className="languagesContainer">
                {LANGUAGES.map((language, key) => {
                  return (<div className="languageTitle" onClick={() => changeLanguageRequest(language.code)}>
                    {language.title}
                    <div className="languageSubtitle">
                      {language.subTitle}
                    </div>
                  </div>)
                })}
              </div>
            </div>
        </div>
      </div>
    );
  }
  return null;
}

LanguageSelectModal.propTypes = {};

const mapStateToProps = state => ({
  language: state.language.language,
  languageSelectModal: state.language.languageSelectModal
});

function mapDispatchToProps(dispatch) {
  return {
    handleModalClose: open => dispatch(handleLanguageSelectModal(open)),
    changeLanguageRequest: lang => dispatch(changeLanguageRequest(lang)),
    dispatch,
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export default compose(withConnect)(LanguageSelectModal);
